import { useRef } from "react";
import { Camera, Loader2 } from "lucide-react";

type Props = {
  onPick: (files: File[]) => void;
  isUploading: boolean;
  disabled?: boolean;
};

/**
 * One tap, straight to the phone's picker. No dropzone: the worker is on a phone at the job, and
 * the office form's "Datei auswählen oder in das Feld ziehen" box is a desktop affordance. No
 * `accept` either — iOS then offers camera, library *and* files, which is exactly the choice.
 */
export const AddFilesButton = ({ onPick, isUploading, disabled = false }: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const blocked = disabled || isUploading;

  return (
    <>
      <button
        type="button"
        onClick={() => inputRef.current?.click()}
        disabled={blocked}
        className="flex min-h-[48px] w-full items-center justify-center gap-2 rounded-[18px] border-2 border-dashed border-[#124093] px-4 text-sm font-medium text-[#124093] transition-colors hover:bg-[#124093]/5 disabled:cursor-default disabled:opacity-60"
      >
        {isUploading ? (
          <Loader2 size={18} className="animate-spin" aria-hidden />
        ) : (
          <Camera size={18} aria-hidden />
        )}
        {isUploading ? "Wird hochgeladen …" : "Foto oder Datei hinzufügen"}
      </button>
      <input
        ref={inputRef}
        type="file"
        multiple
        className="hidden"
        onChange={(event) => {
          const picked = Array.from(event.target.files ?? []);
          // Reset so picking the same file twice in a row fires `change` again.
          event.target.value = "";
          if (picked.length) onPick(picked);
        }}
      />
    </>
  );
};
